module.exports = __webpack_public_path__ + "assets/img/roof.b96769ac.webp";